import React from 'react';
import { CheckCircle2Icon, ArrowRightIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import { Link } from 'react-router-dom';
import { useBooking } from '../contexts/BookingContext';
export function CurriculumOverview() {
  const {
    openBooking
  } = useBooking();
  return <section id="curriculum" className="py-16 md:py-24 bg-slate-50 border-t border-slate-200 overflow-hidden" data-id="element-424">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-425">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-426">
          <div className="order-2 lg:order-1 relative" data-id="element-427">
            <ScrollReveal variant="up" data-id="element-428">
              <div className="absolute -inset-6 bg-[#59d0d4]/15 rounded-[2.5rem] transform -rotate-3 z-0" data-id="element-429"></div>
              <div className="relative z-10 rounded-3xl shadow-2xl overflow-hidden aspect-[4/3]" data-id="element-430">
                <img src="https://cdn.rawproductionsgmbh.de/2n/home/curriculum.jpeg" alt="Curriculum Zahnmedizin" className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000" data-id="element-431" />
              </div>

              <div className="absolute -bottom-8 -right-8 bg-white p-8 rounded-2xl shadow-xl z-20 max-w-xs hidden md:block border border-slate-100 animate-slideUp" style={{
              animationDelay: '500ms'
            }} data-id="element-432">
                <div className="flex items-center gap-5" data-id="element-433">
                  <div className="bg-[#3b7780] text-white rounded-2xl w-14 h-14 flex items-center justify-center font-black text-xl shadow-lg" data-id="element-434">
                    A-Z
                  </div>
                  <div data-id="element-435">
                    <p className="font-extrabold text-slate-700 text-lg" data-id="element-436">
                      Intensiv Curriculum
                    </p>
                    <p className="text-sm font-semibold text-[#748282] uppercase tracking-wider mt-1" data-id="element-437">
                      Zahnmedizin & Praxiserfolg
                    </p>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          </div>

          <div className="order-1 lg:order-2" data-id="element-438">
            <ScrollReveal variant="up" data-id="element-439">
              <h2 className="text-2xl md:text-5xl font-extrabold text-slate-700 mb-6 tracking-tight" data-id="element-440">
                2N Curriculum Zahnmedizin – Fortbildung für den nächsten
                Karriereschritt
              </h2>
              <p className="text-base sm:text-lg text-slate-500 mb-10 leading-relaxed font-medium" data-id="element-441">
                Als Akademie für zahnärztliche Fortbildung bieten wir Ihnen mit
                unserem Curriculum Zahnmedizin eine moderne, strukturierte
                Weiterbildung, die alle relevanten Fachgebiete abdeckt: Von
                ästhetischer Zahnheilkunde über Funktionsdiagnostik bis zur
                minimalinvasiven Chirurgie.
              </p>

              <ul className="space-y-6 mb-10" data-id="element-442">
                <li className="flex items-start group" data-id="element-443">
                  <CheckCircle2Icon className="h-7 w-7 text-[#59d0d4] mr-4 flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform" data-id="element-444" />
                  <span className="text-slate-600 font-medium text-base sm:text-lg" data-id="element-445">
                    Jedes Modul ist von erfahrenen Referenten konzipiert und mit
                    zahlreichen Hands-on-Anteilen ausgestattet.
                  </span>
                </li>
                <li className="flex items-start group" data-id="element-446">
                  <CheckCircle2Icon className="h-7 w-7 text-[#59d0d4] mr-4 flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform" data-id="element-447" />
                  <span className="text-slate-600 font-medium text-base sm:text-lg" data-id="element-448">
                    Richtet sich an alle, die ihre fachlichen Kompetenzen
                    erweitern und neue Behandlungstechniken kennenlernen
                    möchten.
                  </span>
                </li>
                <li className="flex items-start group" data-id="element-449">
                  <CheckCircle2Icon className="h-7 w-7 text-[#59d0d4] mr-4 flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform" data-id="element-450" />
                  <span className="text-slate-600 font-medium text-base sm:text-lg" data-id="element-451">
                    Aktiven Wissenstransfer zwischen Wissenschaft und Praxis
                    erleben.
                  </span>
                </li>
              </ul>

              <div className="bg-white p-5 sm:p-8 rounded-2xl border border-slate-200 shadow-lg hover:border-[#59d0d4]/30 transition-colors mb-8" data-id="element-452">
                <h3 className="font-extrabold text-slate-700 mb-3 text-xl" data-id="element-453">
                  Weiterbildung Oralchirurgie & weitere Kurse
                </h3>
                <p className="text-slate-500 font-medium leading-relaxed" data-id="element-454">
                  Ein besonderer Fokus liegt auf der Weiterbildung
                  Oralchirurgie. Ergänzend bieten wir Kurse zu Parodontologie,
                  Implantologie, Prothetik sowie digitale Zahnmedizin und
                  funktionelle Rehabilitation an.
                </p>
              </div>

              <button onClick={openBooking} className="inline-flex items-center justify-center px-6 py-3.5 text-base sm:px-8 sm:py-4 sm:text-lg font-bold rounded-md text-white bg-[#3b7780] hover:bg-[#2d5f66] transition-all hover:scale-105 shadow-lg" data-id="element-455">
                Jetzt Kursplan sichern
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-456" />
              </button>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>;
}